import { Controparte } from "src/app/common/models/controparte";

export function refreshContropartePrimaria(controparti: Controparte[] , contropartiUpdated:Controparte) : Controparte[]{
    let contropartiFiltred = [];
    if(controparti && controparti.length > 0){
        contropartiFiltred = controparti.filter(controparte => controparte.parte.id !== contropartiUpdated.parte.id);
        if(contropartiFiltred && contropartiFiltred.length > 0){
            contropartiFiltred.forEach(element => {
                if(contropartiUpdated.primario){
                    element.primario = false;
                }
            });
            contropartiFiltred.push(contropartiUpdated);
        } else {
            return controparti;
        }
    } else {
        contropartiFiltred.push(contropartiUpdated);
    }
    return contropartiFiltred;
}